/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";
import { AppointmentStatusResource } from "./AppointmentStatusResource";




export class AppointmentResource extends CMSResource {

	id: number;

	appointmentStatus: AppointmentStatusResource;

	departmentId: number;

	departmentScheduleIntervalId: number;

	/**
	 * The email of the user to whom it is assigned
	 */
	assignedUserEmail: string;

	firstName: string;

	lastName: string;

	phone: string;

	email: string;

	otherDetails: string;

	statusResolutionDetails: string;

	createdDate: Date;

	unlockSlot: boolean;

	showDetailsOnResponsive: boolean = false;

}
